import jwtDecode from 'jwt-decode';

import axios from 'axios'
import moment from 'moment'
import { useSelector } from 'react-redux';
 



// Check if the user is logged in 
export const isLoggedIn = (user) =>  {

 
	////console.log('isLoggedIn start function ...');
	// const obj = getItemStorage(`${process.env.REACT_APP_STORAGE_AUTH_USER}`);
	// const obj = JSON.parse(localStorage.getItem(process.env.REACT_APP_STORAGE_AUTH_USER) ?? '{}')
    
	
	
	////console.log('isLoggedIn > getItemStorage > ' , obj);
	
	if (user && user?.token) {

		const { token } = user;
		let tokenExpiration = jwtDecode(token).exp;

		if (tokenExpiration < new Date().getTime() / 1000) {
			
			// delete token from storage 
			// localStorage.removeItem(`${process.env.REACT_APP_STORAGE_AUTH_USER}`)
			// localStorage.removeItem(`${process.env.REACT_APP_STORAGE_AUTH_ORG}`)

			 

			return false;
		} else {
			return true;
		}
	}
	return false;

	 
}


 

// export function verifySession() {

// 	return new Promise(async (resolve, reject) => {
		
		 
// 		// const obj = JSON.parse(localStorage.getItem(process.env.REACT_APP_STORAGE_AUTH_USER) ?? '{}')
//         const { user } = useSelector((state) => state.auth)
		
// 		if (user && user.token) {
			
// 			const { token } = user;
// 			// Verify token
// 			await axios
// 				.post(`${process.env.REACT_APP_API_URL}/users/session/verify`, { 
// 					token : token 

// 				})
// 				.then(res => res.data )
// 				.then(res => {

// 					const expiredTime = res.exp;
// 					if(moment().diff(moment(expiredTime*1000) , 'minutes') < 0 ){
// 						resolve(token)
// 					}else{

// 						reject({
// 							error : 'expired_session'
// 						})
// 					}
					 
				 
// 				})
// 				.catch(err => {
// 					reject({
// 						error : err
// 					});
// 				})
// 		} else {
// 			reject({
// 				error: "no_token"
// 			})
		 
// 		}
// 	});

		
// }